import classNames from "classnames"
import React, { useMemo } from "react"

import RatingStar from "./RatingStar"
import { Color } from "../../../constants/V2/color"

import { getTextColorClass } from "@utils/V2/color"

//TODO make this more generic as a star rating component, that takes in a logo, rating and num reviews
type GoogleLogoProps = {
  color: Color
}

export const GoogleLogo = ({ color }: GoogleLogoProps) => {
  return (
    <svg
      y="6"
      fill="none"
      viewBox="0 0 92 31"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("h-24 md:h-32 lg:h-40", getTextColorClass(color))}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.803 10.8691H22.4529V10.8684C22.4529 10.8684 22.6456 11.6579 22.6456 13.024C22.6456 19.4994 18.0959 23.8779 11.8808 23.8779C4.81416 23.8779 0.0141602 17.9694 0.0141602 11.9098C0.0141602 5.72558 5.11674 0.000244141 11.7127 0.000244141C16.8924 0.000244141 19.7326 3.25217 19.7326 3.25217L17.5196 5.60856C17.5196 5.60856 15.4087 3.25948 11.8257 3.25948C7.18181 3.25948 3.47798 7.04822 3.47798 11.9676C3.47798 17.0176 7.36349 20.6205 11.8158 20.6205C15.2963 20.6205 18.9831 18.677 19.356 14.1196H11.803V10.8691ZM35.4051 16.1962C35.4051 13.3169 33.3688 11.5299 31.2198 11.5299C28.8049 11.5299 26.9496 13.5155 26.9496 16.1735C26.9496 18.8901 28.8283 20.8516 31.2099 20.8516C33.3773 20.8516 35.4051 19.0141 35.4051 16.1962ZM23.675 16.1266C23.675 12.0289 26.8067 8.51551 31.1765 8.51551C34.7691 8.51551 38.6645 11.133 38.6645 16.2158C38.6645 20.6507 35.3159 23.8639 31.2281 23.8639C26.7129 23.8639 23.675 20.285 23.675 16.1266ZM47.535 11.5299C49.6839 11.5299 51.7202 13.3169 51.7202 16.1962C51.7202 19.0141 49.6925 20.8516 47.5254 20.8516C45.1435 20.8516 43.2647 18.8901 43.2647 16.1735C43.2647 13.5155 45.1204 11.5299 47.535 11.5299ZM47.4914 8.51551C43.1217 8.51551 39.9899 12.0289 39.9899 16.1266C39.9899 20.285 43.0274 23.8639 47.5426 23.8639C51.6305 23.8639 54.9791 20.6507 54.9791 16.2158C54.9791 11.133 51.0836 8.51551 47.4914 8.51551ZM67.7699 16.2081C67.7699 13.2589 65.7507 11.5319 63.7841 11.5319C61.6789 11.5319 59.6124 13.2904 59.6124 16.2362C59.6124 19.072 61.6021 20.8576 63.7404 20.8576C65.7546 20.8576 67.7699 19.2055 67.7699 16.2081ZM56.3301 16.1914C56.3301 12.1361 59.4828 8.52289 63.4939 8.52289V8.52325C65.2396 8.52325 66.5552 9.21876 67.5173 10.2847V8.98473H70.6459V22.775C70.6459 28.1928 67.6066 30.7763 63.6187 30.7763C59.9725 30.7763 57.9244 28.4689 56.9068 26.2569L59.7748 25.0235C60.1723 26.013 61.3154 27.7558 63.5949 27.7558C65.9543 27.7558 67.5173 26.1703 67.5173 23.5224V22.0093C66.6825 23.0057 65.5515 23.8742 63.4249 23.8742C59.9853 23.8742 56.3301 20.8106 56.3301 16.1914ZM84.6868 11.4559C86.05 11.4559 87.0313 12.2015 87.448 13.0952L80.7661 15.9675C80.4781 13.7439 82.5264 11.4559 84.6868 11.4559ZM84.5565 8.50509C80.773 8.50509 77.5961 11.6012 77.5961 16.1692C77.5961 21.003 81.1371 23.8699 84.9199 23.8699C88.0772 23.8699 90.015 22.0938 91.1712 20.5021L88.5917 18.737C87.9225 19.8051 86.8036 20.8495 84.9359 20.8495C82.8381 20.8495 81.8735 19.668 81.2758 18.5234L91.2815 14.2535L90.762 13.0025C89.7956 10.5518 87.5407 8.50582 84.5568 8.50582L84.5565 8.50509ZM76.1129 23.4144H72.8262V0.793889H76.1129V23.4144Z"
        fill="currentColor"
      />
    </svg>
  )
}

type GenericRatingProps = {
  ratingColor: Color
  rating: number
  className?: string
  label?: string
}

const RatingStars = ({ ratingColor, rating }: GenericRatingProps) => {
  const stars = useMemo(() => {
    const starsArray = []

    for (let i = 1; i <= 5; i++) {
      let fillPercentage = 0

      if (i <= rating) {
        fillPercentage = 100
      } else if (i - 1 < rating) {
        const decimalPart = rating - (i - 1)
        fillPercentage = Math.round(decimalPart * 100)
      }

      starsArray.push(
        <RatingStar key={i} fill={fillPercentage} color={ratingColor} />
      )
    }

    return starsArray
  }, [rating, ratingColor])

  return <div className="flex items-center gap-4">{stars}</div>
}

export default RatingStars
